import { render } from "./StamfordTryeRange.vue?vue&type=template&id=4fecce22&ts=true"
import script from "./StamfordTryeRange.vue?vue&type=script&lang=ts"
export * from "./StamfordTryeRange.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__